export function useSettings() {
  const landingPageOrigin =
    import.meta.env.VITE_REACT_LANDING_PAGE_ORIGIN ||
    'https://investinslovakia.eu'
  return {
    getLandingPageLink: (path: string) => {
      return `${landingPageOrigin}/${path}`
    },
    googleApi: {
      mapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
      clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
    },
    veriff: {
      host: import.meta.env.VITE_VERIFF_HOST || '',
      apiKey: import.meta.env.VITE_VERIFF_API_KEY || '',
    },
    turnstile: {
      siteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
    },
  }
}
